import { tokenManager } from "../utils/tokenManager";
import { isAdminUser, loadAccountAccess } from "../utils/appRole.js";

const TAB_KEY = "omni_watch_dashboard_tab";
const VIEW_KEY = "omni_watch_camera_view";
const PREVIEW_ID_KEY = "omni_watch_preview_camera_id";
const LAST_ID_KEY = "omni_watch_last_camera_id";
const ROLE_KEY = "omni_watch_role";

export type DashboardTabId = "cameras" | "preview";
export type CameraViewMode = "list" | "grid";
export type AppRole = "admin" | "user";

function safeGet(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    /* ignore quota / private mode */
  }
}

export function getDashboardTab(): DashboardTabId {
  // Live View opens in a modal; always land on the Cameras surface.
  return "cameras";
}

export function setDashboardTab(tab: DashboardTabId): void {
  safeSet(TAB_KEY, tab);
}

export function getCameraViewMode(): CameraViewMode {
  return "grid";
}

export function setCameraViewMode(_mode: CameraViewMode): void {
  safeSet(VIEW_KEY, "grid");
}

export function getPreviewCameraId(): string | null {
  return safeGet(PREVIEW_ID_KEY);
}

export function setPreviewCameraId(id: string | null): void {
  if (id == null) {
    try {
      sessionStorage.removeItem(PREVIEW_ID_KEY);
    } catch {
      /* ignore */
    }
    return;
  }
  safeSet(PREVIEW_ID_KEY, id);
  safeSet(LAST_ID_KEY, id);
}

/** Alias used by camera dashboard code. */
export const persistPreviewCameraId = setPreviewCameraId;

export function getLastCameraId(): string | null {
  return safeGet(LAST_ID_KEY);
}

export function getAppRole(): AppRole {
  const access = loadAccountAccess();
  if (access?.isAdmin) return "admin";
  const user = tokenManager.getUser() as Record<string, unknown> | null;
  if (user) return isAdminUser(user, access) ? "admin" : "user";
  const v = safeGet(ROLE_KEY);
  if (v === "admin" || v === "user") return v;
  return "user";
}
